import { render, staticRenderFns } from "./network-query.vue?vue&type=template&id=5f75a95c&"
import script from "./network-query.vue?vue&type=script&lang=ts&"
export * from "./network-query.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports